export default "__VITE_PUBLIC_ASSET__82d1ca1e__"